import { Link } from 'react-router-dom'

export const Footer = () => {
  return (
    <footer className="border-t border-border-light bg-surface-light py-12 dark:border-border-dark dark:bg-surface-dark">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 md:flex-row md:px-10 lg:px-20">
        <div className="flex items-center gap-3">
          <div className="flex size-8 items-center justify-center rounded bg-primary text-white">
            <span className="material-symbols-outlined !text-lg">grid_view</span>
          </div>
          <span className="font-bold text-text-main-light dark:text-text-main-dark">
            Binder Tech Solutions
          </span>
        </div>
        <div className="flex flex-wrap justify-center gap-8 text-sm font-medium text-text-sub-light dark:text-text-sub-dark">
          <Link
            to="/terms-and-conditions"
            className="text-gray-600 hover:text-primary transition-colors"
          >
            Terms and Conditions
          </Link>

          <Link
            to="/privacy-policy"
            className="text-gray-600 hover:text-primary transition-colors"
          >
            Privacy Policy
          </Link>

          <Link
            to="/contact-us"
            className="text-gray-600 hover:text-primary transition-colors"
          >
            Contact Us
          </Link>
        </div>
        <div className="text-sm text-text-sub-light dark:text-text-sub-dark opacity-60">
          © 2024 Binder Tech Solutions. All rights reserved.
        </div>
      </div>
    </footer>
  )
}

